import { 
  GET_CONVERSION_LOG_STICKY_COLUMNS, 
  GET_CONVERSION_LOG_STICKY_COLUMNS_ERROR, 
  GET_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS, 
  UPDATE_CONVERSION_LOG_STICKY_COLUMNS, 
  UPDATE_CONVERSION_LOG_STICKY_COLUMNS_ERROR, 
  UPDATE_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS 
} from "./actionTypes"

export const getConversionLogStickyColumns = () => {
  return {
    type: GET_CONVERSION_LOG_STICKY_COLUMNS,
  }
}

export const getConversionLogStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getConversionLogStickyColumnsError = error => {
  return {
    type: GET_CONVERSION_LOG_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

export const updateConversionLogStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_CONVERSION_LOG_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateConversionLogStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateConversionLogStickyColumnsError = error => {
  return {
    type: UPDATE_CONVERSION_LOG_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}